<div *ngIf='userData' [formGroup]='signatureForm' class='SetSignature'>
  <div class='SetSignature-header'>
    <div class='row'>
      <div class='col col-12 text-left d-flex flex-row'>
        <div class='Breadcrumbs'>
          <div class='Breadcrumbs-items'>
            <a [routerLink]="['/contents']"
            >
              <mat-icon class='Breadcrumbs-icon back'
              >keyboard_backspace
              </mat-icon
              >
            </a
            >
            <a [routerLink]="['/contents']" class='Breadcrumbs-item'
            >Set Signature</a
            >
          </div>
        </div>
        <app-info-tip-button [type]="'signature'"></app-info-tip-button>
      </div>
    </div>
    <div class='SetSignature-body mt-3 mt-sm-5 p-0 p-sm-5'>
      <h2>Signature</h2>
      <div class='SetSignature-form mt-2 mt-sm-3 p-1 p-sm-5'>
        <app-editor formControlName='signature'></app-editor>
        <div *ngIf="signatureForm.get('signature').touched && signatureForm.get('signature').hasError('required')"
             class='alert alert-danger'>
          <p>Signature cannot be empty</p>
        </div>
      </div>
      <div class='mt-5'>
        <mat-checkbox formControlName='content_signature'
        >Update all campaign content signatures
        </mat-checkbox
        >
      </div>
      <div class='SetSignature-footer mt-4 ms-5'>
        <app-button
          [Click]='onCancelClick'
          [color]="'blue'"
          [size]="'small'"
          [text]="'Cancel'"
          class='SetSignature-footer-button'></app-button>
        <app-button
          [Click]='onSaveClick'
          [color]="'orange'"
          [observeApi]='true'
          [size]="'small'"
          [text]="'Save'"
          class='SetSignature-footer-button'></app-button>
      </div>
    </div>
  </div>
</div>
